import { useCurrentSessionId } from '@heidi/runtime/shell';
import { useQuerySessionById } from '@heidi/session/data';

export const usePatientProfile = () => {
  const sessionId = useCurrentSessionId();
  const { data: patientProfile } = useQuerySessionById({
    sessionId,
    select: (data) => data?.patient_profile,
  });

  return {
    patientProfile,
  };
};
